import React from 'react';

export default function (props) {
  return (
    <svg className={props.className} style={props.style} focusable="false" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
    </svg>
  );
}
